import CatalogsSelectView from "../../../viewComponents/CatalogsSelectView";

const DirectRewardsRedemptionOutcome = ({ outcome }) => {
  const renderRewardExpirationWindowValue = () => {
    if (outcome?.outcomeData?.reward_expiration_window) {
      return (
        <div style={{ fontSize: "14px", color: "#333", marginBottom: "4px" }}>
          {outcome?.outcomeData?.extra_data.rewardWindow}{" "}
          {outcome?.outcomeData?.extra_data.timeframe}
        </div>
      );
    }

    return <span style={{ fontSize: "14px", color: "#666" }}>-</span>;
  };
  return (
    <div>
      <CatalogsSelectView data={outcome?.outcomeData} />
      <div style={{ marginBottom: "16px" }}>
        <div className="additional-fields-container">
          <div className="field-pair" style={{ flexBasis: "31% !important" }}>
            <span className="field-label">Reward Expiration Window: </span>
          </div>
          <div className="field-pair-two-column">
            {renderRewardExpirationWindowValue()}
          </div>
          <div className="field-pair" style={{ flexBasis: "31% !important" }}>
            <span className="field-label">
              Rewards are only valid during the campaign duration:{" "}
            </span>
          </div>
          <div className="field-pair-two-column">
            <div style={{ fontSize: "14px", color: "#333", marginBottom: "4px" }}>
              {outcome?.outcomeData?.extra_data?.restrictExpiration ? "Yes" : "No"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DirectRewardsRedemptionOutcome;
